import React from 'react';
import { Box, Chip, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  frame: {
    ...theme.globalClasses.frame,
    marginTop: '5px',
  },
}));

/**
 * The Patient Action Box displays the data:
 * - action
 * - description
 * - checkins (number)
 *
 * If there is no data, the box will not be displayed.
 * If there is data but no checkins, default to 0/7 Check-ins.
 *
 * @param {object} data
 * @returns
 */
const PatientActionBox = ({ data }) => {
  const classes = useStyles();

  return (
    <>
      {(data && data.action) || data.description || data.checkins ? (
        <Grid
          item
          sx={{ minWidth: '100%', maxWidth: '298px', width: '100%' }}
        >
          <Typography variant={'overline'}>This Week's Actions</Typography>
          <Box className={classes.frame}>
            <Typography variant={'h3'}>{data?.action}</Typography>
            <Typography variant={'body1'}>{data?.description}</Typography>
            {/* TODO: Add checkins back in when we have the data*/}
            {/* <Chip
              style={{ lineHeight: '18px' }}
              label={`${data?.checkins ? data.checkins : 0}/XXX Check-ins`}
            /> */}
          </Box>
        </Grid>
      ) : (
        ''
      )}
    </>
  );
};

export default PatientActionBox;
